import { Card, Divider, Flex } from 'antd'
import { useTheme } from 'antd-style'

import { InquiryDocumentResponse } from 'src/api/requests'
import { Text } from 'src/components'
import { useLocales } from 'src/locales'

import { useStyles } from './styles'

type Props = {
  data?: InquiryDocumentResponse
}

export const InputsCommentSection = ({ data }: Props) => {
  const { t } = useLocales()

  const palette = useTheme()

  const { styles } = useStyles()

  return (
    <>
      {(data?.comment || data?.beneficiaryComment) && (
        <Card title={t('common.comment')} className={styles.commentCardWrapper}>
          {data?.comment && (
            <Flex vertical gap={8} className={styles.commentCard}>
              <Text size="lg">{t('stock.provider')}</Text>
              <div
                style={{
                  padding: '16px 10px',
                  borderRadius: 6,
                  backgroundColor: palette.colorFillSecondary
                }}
              >
                {data?.comment}
              </div>
              <Text size="lg" color={palette.colorTextTertiary}>
                {data?.commentBy?.firstName} {data?.commentBy?.lastName} -{' '}
                {data?.supplier?.name}
              </Text>
            </Flex>
          )}
          {data?.beneficiaryComment && (
            <>
              <Divider className={styles.commentDivider} />
              <Flex vertical gap={8} className={styles.commentCard}>
                <Text size="lg">{t('stock_applications.beneficiary')}</Text>
                <div
                  style={{
                    padding: '16px 10px',
                    borderRadius: 6,
                    backgroundColor: palette.colorFillSecondary
                  }}
                >
                  {data?.beneficiaryComment}
                </div>
                <Text size="lg" color={palette.colorTextTertiary}>
                  {data?.beneficiaryCommentBy?.firstName}{' '}
                  {data?.beneficiaryCommentBy?.lastName} -{' '}
                  {data?.beneficiary?.name}
                </Text>
              </Flex>
            </>
          )}
        </Card>
      )}
    </>
  )
}
